import { laboratories } from '@/config/constants';

const availableLaboratories = [
  { value: laboratories.CHIM, label: 'enums.laboratories.CHIM' },
  { value: laboratories.MICR, label: 'enums.laboratories.MICR' },
];

const signDocumentsFilters = [
  {
    name: 'laboratory',
    label: 'laboratory',
    type: 'select',
    whereOperator: '=',
    options: availableLaboratories,
  },
  {
    name: 'isSigned',
    label: 'status',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.signedStatus.signed', value: true },
      { label: 'enums.signedStatus.unsigned', value: false },
    ],
  },
  {
    name: 'description',
    label: 'description',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'signedAt',
    label: 'signedAt',
    type: 'dateDay',
    whereOperator: '=',
  },
];

export default signDocumentsFilters;
